var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.length === 0 && !_vm.isView)?_c('Banner',{directives:[{name:"clean-html",rawName:"v-clean-html",value:(_vm.t('monitoringReceiver.webhook.banner', {}, _vm.raw=true)),expression:"t('monitoringReceiver.webhook.banner', {}, raw=true)"}],attrs:{"color":"info"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }